/* eslint no-console:0 */
require('cwc')
